const HeadingOne = ({ ...props }) => {
    const { image, icon, heading, className} = props;



    return (
        <h1 className={className}>
            {icon && (<span className="icon">{icon}</span>)}
            {image && (<img src={image} className="icon"/>)}
            {heading && (<span>{heading}</span>)}
        </h1>
    );
};

export default HeadingOne;
